import { QRCodeSVG } from 'qrcode.react'
import type { ComponentProps } from 'react'
import logo from '@/assets/logoNovo.svg'

// Proporção do logo em relação à largura do QR: discreto, mas ainda reconhecível
const LOGO_RATIO = 0.2

type BrandedQrCodeProps = Omit<
	ComponentProps<typeof QRCodeSVG>,
	'imageSettings' | 'size'
> & {
	size: number
}

// QR Code padrão do app: logo encaixado na malha (excavate), sem caixa por cima.
// O logo ocupa ~4% da área, dentro do que a correção de erro (Q/H) tolera.
export const BrandedQrCode = ({
	size,
	level = 'H',
	...props
}: BrandedQrCodeProps) => {
	const logoSize = Math.round(size * LOGO_RATIO)

	return (
		<QRCodeSVG
			imageSettings={{
				src: logo,
				width: logoSize,
				height: logoSize,
				excavate: true,
			}}
			level={level}
			size={size}
			{...props}
		/>
	)
}
